import React from 'react';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { Actor_ } from '../../../components/actor/Actor_';
export class SkeletonsMemorizePoints extends SkeletonRegistryCategory {
    label = 'MemorizePoints';
    constructor(parent) {
        super(parent);
        super.init();
    }
    memorizePointsWrappedInAspectTasks = () => new SkeletonRegistryItem({
        label: 'Wordtasks wrapped in Aspect "tasks"',
        jsx: ({ questionMemorizePoints }) => {
            return (React.createElement(Aspect_, { aspect: questionMemorizePoints.inner, key: questionMemorizePoints.tid },
                React.createElement(Actor_, { actor: questionMemorizePoints.questionPart, key: questionMemorizePoints.questionPart.tid }),
                React.createElement(Aspect_, { aspect: questionMemorizePoints.ownAspect.tasks, key: questionMemorizePoints.ownAspect.tasks.tid }, questionMemorizePoints.memorizePointsForUI.wordTasksToDisplay.map(task => (React.createElement(Actor_, { actor: task, key: task.tid }))))));
        },
    });
    draftMemorizePointsStructure_base = () => new SkeletonRegistryItem({
        label: 'MemorizePoints Structure WrappedPoints',
        jsx: ({ questionMemorizePoints }) => {
            if (!questionMemorizePoints)
                return null;
            return (React.createElement(Aspect_, { aspect: questionMemorizePoints.inner },
                React.createElement(Actor_, { actor: questionMemorizePoints.questionPart }),
                React.createElement(Actor_, { actor: questionMemorizePoints, structureTemplate: React.createElement("div", { "data-aspect": "points" }, questionMemorizePoints.memorizePointsForUI.wordTasksToDisplay.map(wordTask => (React.createElement(Actor_, { actor: wordTask, key: wordTask.id })))) })));
        },
    });
    draftMemorizePointsStructure_wordtasks = () => new SkeletonRegistryItem({
        label: 'MemorizePoints Structure WordTasks',
        jsx: ({ questionMemorizePoints }) => {
            if (!questionMemorizePoints)
                return null;
            return (React.createElement(Aspect_, { aspect: questionMemorizePoints.inner },
                React.createElement(Actor_, { actor: questionMemorizePoints.questionPart }),
                questionMemorizePoints.memorizePointsForUI.wordTasksToDisplay.map(wordTask => (React.createElement(Actor_, { actor: wordTask, key: wordTask.id })))));
        },
    });
    gapStructure_wordTaskOfGapByTagname = () => new SkeletonRegistryItem({
        label: 'GapStructure: Wordtask of by Tagname of Gap',
        jsx: ({ questionMemorizePoints, at }) => {
            if (!questionMemorizePoints)
                return null;
            const taskTagName = at.actor.tags.find((role) => role.includes('task'));
            if (!taskTagName)
                return false;
            const nth = parseInt(taskTagName.split('task')[1]);
            if (questionMemorizePoints.wordTasks.length < nth)
                return false;
            const wordTask = questionMemorizePoints.wordTasks[nth - 1];
            if (!wordTask)
                return false;
            return (React.createElement(Actor_, { actor: wordTask, key: wordTask.id }));
        },
    });
}
